import request from '@/utils/request2'

// 列表(主数据列表)
export function loadContractListDataApi(data) {
  return request({
    url: 'tms-web/contractSetting/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportContractListDataApi(data) {
  return request({
    url: 'tms-web/contractSetting/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveContractApi(data) {
  return request({
    url: 'tms-web/contractSetting/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteContractApi(data) {
  return request({
    url: 'tms-web/contractSetting/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewContractApi(data) {
  return request({
    url: 'tms-web/contractSetting/view',
    method: 'post',
    data
  })
}

// 列表
export function listContractApi(data) {
  return request({
    url: 'tms-web/contractSetting/list',
    method: 'post',
    data
  })
}
